import Swiper, { Navigation, Pagination } from "swiper";

export default class PageSingleBlog {
    constructor() {

        this.section = document.querySelector('.single-blog')

        this.sliderRelacionados = this.section.querySelector(".swiper--single-blog-relacionados")

        this.navigationRelacionadosPrev = this.section.querySelector(".slider-button-prev--single-blog-relacionados")
        this.navigationRelacionadosNext = this.section.querySelector(".slider-button-next--single-blog-relacionados")
        this.paginationRelacionados = this.section.querySelector(".slider-pagination--single-blog-relacionados")

        this.ready();
    }

    ready() {

        if(this.sliderRelacionados) {
            const swiper = new Swiper(this.sliderRelacionados, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: this.navigationRelacionadosNext,
                    prevEl: this.navigationRelacionadosPrev
                },
                pagination: {
                    el: this.paginationRelacionados,
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 22,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                    },
                    768: {
                      slidesPerView: 3.2,
                      spaceBetween: 30,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 23,
                    }
                },
            })
        }
    }
}